import FAQsListSkeleton from './FAQsListSkeleton';
import './FAQsSkeleton.scss';


const FAQsSkeleton = () => {

  return (
    <div className="home__faqs__section__skeleton">
      <div className='left__side__faqs__section__skeleton'>
        <div className='faqs__content__skeleton'>
          <div className='faqs__accent__skeleton'></div>
          <div className='faqs__title__skeleton'></div>
          <div className='faqs__title__skeleton--primary'></div>
          {[...Array(4)].map((_, index) => (
            <div key={index} className='faqs__subtitle__skeleton'></div>
          ))}
          <div className='faqs__subtitle__skeleton--primary'></div>
          <div className='faqs__button__skeleton'></div>
        </div>
      </div>
      <div className='right__side__faqs__section__skeleton'>
        <FAQsListSkeleton />
      </div>
    </div>
  );
};

export default FAQsSkeleton;